module.exports = __webpack_public_path__ + "static/img/Creative-Klima_logo.71afc8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Creative-Klima_logo.jpg
// module id = aUj1
// module chunks = 0